import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { AlertService } from '../../../services/alert.service';
import { DrawerRef } from '../../drawer';
import { PaymentMethodDto, CreatePaymentMethodRequest, UpdatePaymentMethodRequest, PaymentMethodClient } from '../../../api-connector/sso-connector';

@Component({
    selector: 'app-payment-method-dialog',
    templateUrl: './payment-method-dialog.component.html',
    styleUrls: ['./payment-method-dialog.component.scss']
})
export class PaymentMethodDialogComponent implements OnInit {
    form!: FormGroup;
    isEditMode = false;
    data!: { mode: 'add' | 'edit', method?: PaymentMethodDto };
    drawerRef!: DrawerRef;

    constructor(
        private fb: FormBuilder,
        private paymentClient: PaymentMethodClient, // Use client directly
        private spinner: NgxSpinnerService,
        private alertService: AlertService
    ) {
    }

    ngOnInit(): void {
        this.isEditMode = this.data?.mode === 'edit';
        this.initForm();
    }

    initForm(): void {
        const method = this.data?.method;
        this.form = this.fb.group({
            methodCode: [method?.methodCode || '', [Validators.required]],
            methodName: [method?.methodName || '', [Validators.required]],
            description: [method?.description || ''],
            isActive: [method?.isActive ?? true],
            displayOrder: [method?.displayOrder || 0]
        });
    }

    onSubmit(): void {
        if (this.form.invalid) {
            return;
        }

        const formValue = this.form.value;
        this.spinner.show();

        if (this.isEditMode && this.data.method) {
            const request = new UpdatePaymentMethodRequest({
                id: this.data.method.id,
                ...formValue
            });

            // Assuming client has updatePaymentMethod
            (this.paymentClient as any).updatePaymentMethod(request)
                .pipe(finalize(() => this.spinner.hide()))
                .subscribe({
                    next: () => {
                        this.alertService.success('Cập nhật phương thức thành công');
                        this.drawerRef.close({ success: true });
                    },
                    error: () => {
                        this.alertService.error('Có lỗi xảy ra khi cập nhật phương thức');
                    }
                });
        } else {
            const request = new CreatePaymentMethodRequest({
                ...formValue
            });

            // Assuming client has createPaymentMethod
            (this.paymentClient as any).createPaymentMethod(request)
                .pipe(finalize(() => this.spinner.hide()))
                .subscribe({
                    next: (res: any) => {
                        // Check what res returns. Usually ID or object.
                        // Previous code assumed it returns ID in some way.
                        // But client typically returns FileResponse or similar if not typed.
                        // Let's assume response contains ID or we just reload.
                        this.alertService.success('Thêm phương thức thành công');
                        this.drawerRef.close({ success: true, id: res }); // Pass res if it's ID
                    },
                    error: () => {
                        this.alertService.error('Có lỗi xảy ra khi thêm phương thức');
                    }
                });
        }
    }

    onCancel(): void {
        this.drawerRef.close();
    }
}
